<template>
  <div class="map">
    <img
      src="~/assets/images/world_map.webp"
      alt=""
    >
    <template
      v-for="item in linkList"
      :key="item.key"
    >
      <NuxtLink
        v-if="!isOwnArea(item.text)"
        :to="isExternalLink ? `${runtimeConfig.app.baseURL}${item.to.replace(/^\//, '')}` : item.to"
        :external="isExternalLink"
        :data-area="item.key"
        class="map__link"
      >
        <span class="map__text">{{ item.text }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="11"
          viewBox="0 0 7 11"
          fill="none"
        >
          <path
            d="M1 1.5L6 5.5L1 9.5"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      </NuxtLink>
      <div
        v-else
        class="map__link"
        :data-area="item.key"
        @click="scrollToTop"
      >
        <span class="map__text">{{ item.text }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="11"
          viewBox="0 0 7 11"
          fill="none"
        >
          <path
            d="M1 1.5L6 5.5L1 9.5"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </template>
  </div>
</template>

<script setup>

const linkList = [
  { to: '/5/', text: 'ヨーロッパ', key: 'europe' },
  { to: '/9/', text: 'アフリカ', key: 'africa' },
  { to: '/4/', text: '中東', key: 'middleEast' },
  { to: '/1/', text: 'アジア', key: 'asia' },
  { to: '/3/', text: '南アジア', key: 'southAsia' },
  { to: '/2/', text: '東南アジア', key: 'southeastAsia' },
  { to: '/6/', text: 'オセアニア・太平洋', key: 'oceania' },
  { to: '/7/', text: '北アメリカ', key: 'northAmerica' },
  { to: '/8/', text: '中南米', key: 'southAmerica' }
]

const route = useRoute()
const isOwnArea = (targetAreaText) => {
  return route.name === 'area' && areaLabelMap[route.params.area] === targetAreaText
}
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)

</script>

<style lang="scss" scoped>
.map {
  position: relative;
  img {
    width: 100%;
    height: auto;
    aspect-ratio: 1512 / 823;
  }
  &__link {
    position: absolute;
    display: flex;
    align-items: center;
    gap: min(1.33vw, 7px);
    padding: min(1.07vw, 8px) min(2.13vw, 11px) min(1.07vw, 8px) min(3vw, 15px);
    border-radius: 100vmax;
    border: 2px solid #FFF;
    box-shadow: 2px 2px 4px 0 rgb(0 0 0 / .25);
    svg {
      fill: transparent;
    }
    &[data-area="europe"] {
      top: 24%;
      left: 2.5%;
      background-color: #527E23;
    }
    &[data-area="africa"] {
      top: 69%;
      left: 3.4%;
      background-color: #C77928;
    }
    &[data-area="middleEast"] {
      top: 40.3%;
      left: 12.5%;
      background-color: #4577CB;
    }
    &[data-area="asia"] {
      top: 27.9%;
      left: 30%;
      background-color: #4577CB;
    }
    &[data-area="southAsia"] {
      top: 55.9%;
      left: 22.4%;
      background-color: #4577CB;
    }
    &[data-area="southeastAsia"] {
      top: 41.8%;
      left: 38.4%;
      background-color: #4577CB;
    }
    &[data-area="oceania"] {
      top: 64.5%;
      left: 47.1%;
      background-color: #BA507E;
    }
    &[data-area="northAmerica"] {
      top: 27.6%;
      left: 65.4%;
      background-color: #986EB1;
    }
    &[data-area="southAmerica"] {
      top: 80.6%;
      left: 70.9%;
      background-color: #A89B2B;
    }
    path {
      stroke: #fff;
    }
  }
  &__text {
    color: #FFF;
    font-family: "Hiragino Sans";
    font-size: min(3.2vw, 22px);
    font-weight: 600;
    line-height: 1em;
    letter-spacing: .18px;
    user-select: none;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #CCC;
  border-left: 1px solid #CCC;
}
.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 50%;
  padding: 6px;
  background-color: #FFF;
  border-bottom: 1px solid #CCC;
  border-right: 1px solid #CCC;
}
.text {
  display: flex;
  align-items: center;
  gap: 3px;
  .inner {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .flag {
    width: 20px;
    aspect-ratio: 20 / 15;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      outline: .5px solid #ccc;
    }
  }
  .area {
    color: #3569C0;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    text-decoration: underline;
  }
  .time {
    color: #606060;
    font-size: 10px;
    line-height: 1em;
  }
}
.info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
  min-width: 63px;
  .icon {
    width: 30px;
    aspect-ratio: 34 / 25;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .temp {
    display: flex;
    flex-direction: column;
    gap: 3px;
    p {
      text-align: right;
      font-size: 12px;
      font-weight: 600;
      line-height: 1em;
      &.max {
        color: #F64D00;
      }
      &.min {
        color: #0075F3;
      }
    }
  }
}
@media (any-hover: hover) {
.map {
  &__link {
    transition: background-color .2s ease-in-out, border-color .2s ease-in-out;
    path {
      transition: stroke .2s ease-in-out;
    }
    &:hover {
      background-color: #fff;
      &[data-area="europe"] {
        border-color: #527E23;
        path {
          stroke: #527E23;
        }
        .map__text {
          color: #527E23;
        }
      }
      &[data-area="africa"] {
        border-color: #C77928;
        path {
          stroke: #C77928;
        }
        .map__text {
          color: #C77928;
        }
      }
      &[data-area="middleEast"],
      &[data-area="asia"],
      &[data-area="southAsia"],
      &[data-area="southeastAsia"] {
        border-color: #4577CB;
        path {
          stroke: #4577CB;
        }
        .map__text {
          color: #4577CB;
        }
      }
      &[data-area="oceania"] {
        border-color: #BA507E;
        path {
          stroke: #BA507E;
        }
        .map__text {
          color: #BA507E;
        }
      }
      &[data-area="northAmerica"] {
        border-color: #986EB1;
        path {
          stroke: #986EB1;
        }
        .map__text {
          color: #986EB1;
        }
      }
      &[data-area="southAmerica"] {
        border-color: #A89B2B;
        path {
          stroke: #A89B2B;
        }
        .map__text {
          color: #A89B2B;
        }
      }
    }
  }
  &__text {
    transition: color .2s ease-in-out;
  }
}
.link {
  transition: opacity .2s ease-in-out;
  &:hover {
    opacity: .6;
  }
}
}

@media screen and (min-width: 830px) {
  .map {
    &__link {
      gap: min(.58vw, 7px);
      padding: min(.67vw, 8px) min(.92vw, 11px) min(.5vw, 6px) min(1.25vw, 15px);
      &[data-area="europe"] {
        top: 26.5%;
        left: 7.5%;
      }
      &[data-area="africa"] {
        top: 57%;
      }
      &[data-area="middleEast"] {
        left: 14.5%;
      }
      &[data-area="asia"] {
        top: 31.8%;
        left: 28.1%;
      }
      &[data-area="southAsia"] {
        top: 53.9%;
      }
      &[data-area="southeastAsia"] {
        top: 46.4%;
      }
      &[data-area="southAmerica"] {
        top: 76.6%;
        left: 75.9%;
      }
    }
    &__text {
      font-size: min(1.42vw, 17px);
    }
  }
  .list {
    gap: 7px;
    border-top: none;
    border-left: none;
  }
  .link {
    display: flex;
    align-items: center;
    gap: 8px;
    width: calc((100% - 14px) / 3);
    padding: 3px 8px;
    background-color: #FFF;
    border: 1px solid #CCC;
    border-radius: 3px;
  }
  .text {
    .area {
      text-align: center;
    }
    .time {
      text-align: left
    }
  }
}
</style>
